import React, { useCallback, useState } from "react";
import { Alert, Button } from "react-bootstrap";
import ListPodcastModal from "../../components/ListPodcastModal/ListPodcastModal";
import config from "../../config/config.json";
import { Podcast } from "../../types/Podcast";

import PodcastCard from "../../components/PodcastCard/PodcastCard";
import { useAppAuthState } from "../../hooks/use-app-auth-state";
import { useDocumentTitle } from "../../hooks/use-document-title";
import { usePodcasts } from "../../hooks/use-podcasts";
import "./PodcastsHomePage.scss";

const PodcastsHomePage: React.FC = () => {
  useDocumentTitle("Podcasts");
  const { isLoggedIn } = useAppAuthState();

  const [showModal, setShowModal] = useState(false);
  const { podcasts, isLoading, refetch } = usePodcasts();

  const handlePodcastListSuccess = useCallback(
    async (_podcastData: Podcast) => {
      setShowModal(false);
      refetch();
    },
    [refetch],
  );

  return (
    <div className="podcasts-home-page">
      <div className="page-header">Podcasts</div>

      <div className="row">
        <div className="col-lg-8">
          {isLoading ? (
            <Alert variant="info">Loading podcasts...</Alert>
          ) : podcasts.length > 0 ? (
            <div className="podcast-list">
              {podcasts.map((podcast) => (
                <PodcastCard
                  key={podcast.id}
                  podcast={podcast}
                  onUpvote={refetch}
                />
              ))}
            </div>
          ) : (
            <Alert variant="info">No podcasts found.</Alert>
          )}
        </div>
        <div className="col-lg-4 sidebar">
          <div className="inner">
            <div className="explainer-text">
              The <strong>{config.appName}</strong> podcast directory surfaces
              all of the content your favorite VCs and VC firms are producing -
              and they're producing quite a bit of it!
              <br />
              <br />
              It's also totally okay to list excellent tech and entrepreneurship
              podcasts.
            </div>
            <div className="cta-button-wrapper">
              <Button onClick={() => setShowModal(true)} className="btn-icon">
                <span className="material-symbols-outlined">add</span>
                List a Podcast
              </Button>
              {!isLoggedIn && (
                <span className="cta">Sign in to list a podcast</span>
              )}
            </div>
          </div>
        </div>
      </div>

      <ListPodcastModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onSuccess={handlePodcastListSuccess}
      />
    </div>
  );
};

export default PodcastsHomePage;
